import { Singleton } from 'typescript-ioc/es5'
import aqe from '@pushly/aqe'
import { AbstractRequestService } from '@pushly/aqe/lib/services/abstract-request-service'
import { HttpMethod } from '@pushly/aqe/lib/enums'
import { IApiCallOptions, IApiResponse } from '@pushly/aqe/lib/interfaces'
import { CatalogItemResponse } from '../features/catalog/types'

/**
 * Service for catalog API interactions.
 * Extends AbstractRequestService for standardized request handling,
 * cancellation support, and response packaging.
 */
@Singleton
export class CatalogService extends AbstractRequestService {
    public constructor() {
        super()
    }

    /**
     * Fetches catalog items from the domain's default catalog.
     *
     * @param domainId - The domain ID to fetch catalog items for
     * @param options - Standard API call options with query params for search/pagination
     * @returns Standard IApiResponse with catalog item data
     */
    public async fetchCatalogItems(
        domainId: number,
        options?: IApiCallOptions,
    ): Promise<IApiResponse<CatalogItemResponse[]>> {
        const url = `${aqe.defaults.publicApiDomain}/v5/domains/${domainId}/catalogs/default/items`

        // responseType is omitted because the catalog item type (product/event/recipe)
        // is determined at runtime by the catalog's item_type. The response data is used
        // as plain objects matching CatalogItemResponse interfaces.
        return this.request(HttpMethod.GET, url, {
            ...options,
            config: { skipCaseConversion: true },
        } as any) as Promise<IApiResponse<CatalogItemResponse[]>>
    }
}
